



































































import { Component, Vue, Watch } from "vue-property-decorator";
import GenericBTable from "@/core/Generics/GenericBTable";
import BTableColumn from "@/models/base/BTableColumn.model";
import Language from "@/models/language/language.model";
import { BTableColumnType } from "@/enums/BTableColumnType";
import LanguageService from "@/services/language.service";
import i18n from "@/Plugin/i18n.ts";
import { PermissionValue } from "@/enums/PermissionValue";
@Component
export default class LanguageTableComponent extends GenericBTable<Language> {
  isLoading = false;
  languageService = new LanguageService();
  created() {
    this.permissionValue = PermissionValue.IDIOMAS;
    this.tableConfig.controller = "Languages";
    this.formatColumns();
  }

  formatColumns() {
    let idioma = new BTableColumn("name", "table.name", true);
    let key = new BTableColumn("key", "table.code", true);
    this.tableConfig.insertColumns(idioma, key);
    this.tableConfig.actions.customTemplate = true;
  }
  verOpciones(row: Language) {
    this.$router.push(`/Language/${row.id}/LanguageGroup`);
  }
  generateJSON() {
    this.isLoading = true;
    this.languageService
      .generateJSON()
      .then(msg => {
        localStorage.setItem("locales", JSON.stringify(msg));
        this.$i18n.setLocaleMessage(i18n.locale, msg[i18n.locale]);
        this.operationSuccess();
      })
      .finally(() => {
        this.isLoading = false;
      });
  }
}
